const COMPOSER_ROLE_ID = 2;
const PUBLISHING_ROLE_GROUP_ID = 4;

type RoleLike = {
  id?: number;
  roleId?: number;
  contributorRoleGroupId?: number;
};

export function isPublishingContributorRole(role: RoleLike): boolean {
  if (role.contributorRoleGroupId === PUBLISHING_ROLE_GROUP_ID) return true;
  if (role.contributorRoleGroupId != null) return false;
  return (role.roleId ?? role.id) === COMPOSER_ROLE_ID;
}

export function artistContributorRoles<T extends RoleLike>(roles: T[]): T[] {
  return roles.filter((role) => !isPublishingContributorRole(role));
}

export function composerContributorRoles<T extends RoleLike>(roles: T[]): T[] {
  const publishing = roles.filter(isPublishingContributorRole);
  return publishing.length > 0 ? publishing : roles;
}

export function sanitizeUpc(upc?: string | number | null): string | undefined {
  if (upc == null) return undefined;
  const normalized = String(upc).trim();
  return normalized === '' ? undefined : normalized;
}
